const { MY_NODE } = process.env;

if (MY_NODE === 'production') {
  module.exports = require('./index.prod.js');
} else if (MY_NODE === 'testing') {
  module.exports = require('./index.qa.js');
} else {
  module.exports = require('./index.dev.js');
}
